/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetServicingFees = (loanNo: string, feeNo: string) => {
  const [servicingFees, setServicingFees] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();

  const { reset } = useAbortController();

  const getServicingFees = useCallback(async () => {
    if (!token || !loanNo || loanNo.length !== 12 || !feeNo) {
      return;
    }
    setLoading(true);
    const url = `live/loan/${loanNo}/fee/${feeNo}/list`;

    const controller = reset();
    const config = { signal: controller.signal };

    const headers = {
      'Session-Token': token,
      'Content-Type': 'application/json',
    };

    try {
      let response = await axiosCall({ url: url, method: 'get' }, config, headers);
      setServicingFees(response);
      setErrorMessage('');
      setLoading(false);
    } catch (error) {
      setErrorMessage(`Error Loading Servicing Fees for loan ${loanNo}.`);
      setLoading(false);
      console.error(error.message);
    }
  }, [loanNo, feeNo, reset, token]);

  useEffect(() => {
    getServicingFees();
  }, [getServicingFees]);

  return {
    servicingFees,
    loading,
    errorMessage,
  };
};

export default useGetServicingFees;
